/**
 * Which header button carries the stage (David, Oct 15 2026: one main button per stage). Kept out
 * of SignatureControl.tsx so that file exports components only.
 */
import { SENDABLE } from './signatureLabels';
import type { LetterSignature } from './useLetterSignature';
import type { ReferenceLetterDraft } from '../../types/referenceLetterDraft';

/**
 * Before the letter goes out, sending it is the main action (David, Oct 15 2026) — unless nobody
 * can sign it, when the download is all there is.
 */
export const sendIsMain = (draft: ReferenceLetterDraft, sig: LetterSignature) =>
  // `null` is the proxy saying there is nobody; a missing field is an older proxy that did not say.
  // A letter marked Done by hand is closed: sending stays possible, but is not the next step.
  Boolean(sig.view && !sig.view.done && SENDABLE.has(sig.view.state) && draft.signatory !== null && draft.signatory?.active !== false);

/** Download .docx's weight: main when nothing else is, outlined beside Send, quiet once sent. */
export function docxVariant(draft: ReferenceLetterDraft, sig: LetterSignature): 'primary' | 'outline' | 'ghost' {
  if (sig.view && !SENDABLE.has(sig.view.state)) return 'ghost';
  return sendIsMain(draft, sig) ? 'outline' : 'primary';
}
